import {Component, h, Host, Prop} from '@stencil/core';

@Component({
    tag: 'access-button',
    shadow: false,
})

export class AccessButton {

    @Prop() state = 'open';
    @Prop() size = 'icon'
    @Prop() href;
    @Prop() color = 'primary';

    render() {
        const buttonClass = 'button--' + this.color;
        return (
            this.size=='icon' ?
                <Host size={this.size} state={this.state} color={this.color}><slot /></Host>
                :
                <Host size={this.size} state={this.state} color={this.color} class={buttonClass}><slot/></Host>
        );
    }
}
